import { createContext, useCallback, useMemo, useState } from "react";

// Sign in and sign up live in a single global modal instead of on their own
// pages, so anything anywhere in the tree can open them without navigating away
// from what the customer was doing.
export const AuthModalContext = createContext({
    authModal: null,
    dfCard: false,
    redirectTo: null,
    openSignIn: () => {},
    openRegister: () => {},
    closeAuthModal: () => {},
});

export const AuthModalProvider = ({ children }) => {
    // null | 'signin' | 'register'
    const [authModal, setAuthModal] = useState(null);
    // set when the customer came in through a Desi Family entry point, which
    // changes the sign-up copy and issues a reward card
    const [dfCard, setDfCard] = useState(false);
    // where to send the customer once they are signed in (null = stay put)
    const [redirectTo, setRedirectTo] = useState(null);

    const openSignIn = useCallback((options = {}) => {
        setDfCard(false);
        setRedirectTo(options.redirectTo ?? null);
        setAuthModal("signin");
    }, []);

    const openRegister = useCallback((options = {}) => {
        setDfCard(Boolean(options.dfCard));
        setRedirectTo(options.redirectTo ?? null);
        setAuthModal("register");
    }, []);

    const closeAuthModal = useCallback(() => {
        setAuthModal(null);
        setDfCard(false);
        setRedirectTo(null);
    }, []);

    const value = useMemo(
        () => ({ authModal, dfCard, redirectTo, openSignIn, openRegister, closeAuthModal }),
        [authModal, dfCard, redirectTo, openSignIn, openRegister, closeAuthModal]
    );

    return <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>;
};
